import "./Test-question-card.scss";
import PauseSvg from "@Assets/svg/Dashboard-svgs/pause.svg";
import { useCallback, useEffect, useRef, useState } from "react";
import { QuestionCardIndex } from "./Question-card";
import { QuestionPaletteIndex } from "./Question-palette";
import { getQuestion, getTestSeriesQuestion, postFinalSubmitTest, postPauseTest, postQuestion, postResumeTest, postSubmitQuestion, postSubmitTestSeriesQuestion, postTestSeriesQuestion, postTimerTest } from "../../services/MockTest.service";
import { APIResponse, APIStatus } from "@Src/services/baseInterfaces";
import { useNavigate, useParams } from "react-router-dom";
import { MyTimer } from "@Components/CountDown/CountDown";
import Play from "@Assets/svg/MockTest-svgs/Play.svg";
import { FullQuestionPaper } from "../FullQuestionPaper/FullQuestionPaper";
import { AppRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { toast } from "react-hot-toast";
import { InstructionSetIndex } from "../InstructionSet/InstructionSet";
import { getUserDeviceDetails } from "@Src/utils/service/device-details.service";
import { useAppSelector } from "@Src/app/hooks";
import { CountDownActions, TestTypes, StopWatchActions } from '@Constants/app.constant';
import { QuestionPaperFooter } from "../QuestionPaperFooter/QuestionPaperFooter";
import { PauseTestDialog } from "@Components/PauseTestDialog/PauseTestDialog";
import { EndTestDialog } from "@Components/EndTestDialog/EndTestDialog";
import { ExpireTimeEndTestDialog } from "@Components/ExpireTimeEndTestDialog/ExpireTimeEndTestDialog";
import { QuestionpaperrightFooter } from "../QuestionPaperFooter/Questionpaperrightfooter";
import { StopWatch } from "@Components/StopWatch/StopWatch";
import MarkReview from "@Assets/svg/MockTest-svgs/MarkReview.svg";
import { useTimer } from 'react-use-precision-timer';
import SvgIcon from '@Components/icons/SvgIcon';
import { ClockTimer } from './ClockTimer';
import { QuestionsNotAvailableDialog } from "@Components/QuestionsNotAvailableDialog/QuestionsNotAvailableDialog";
import { clearTimeout as clearWorkerTimeout, setTimeout as setWorkerTimeout } from "worker-timers";

export const TestQuestionIndex = ({ testId, noOfQuestion, timeDuration, isTestSeries, testIds, testName, generalInstruction }: any) => {
  const examType1 = window.location.pathname.includes(TestSereisRouteURL.FULL_MOCK_TEST_SERIES);
  const examType4 = window.location.pathname.includes(TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES);
  const navigation = useNavigate();
  const [instruction, setinstruction] = useState(false);
  const [fullQuestionPaperMode, setFullQuestionPaperMode] = useState(false);
  const [Pauesedialog, setPauesedialog] = useState(false);
  const [questionsStore, setAllQuestions] = useState<any[]>([]);
  const [endTestDialog, setEndTestDialog] = useState(false);
  const [action, setAction] = useState('');
  const [isTimerRunning, setIsTimerRunning] = useState(true);
  const [expireTestDialog, setExpireTestDialog] = useState(false);
  const [Qustpalette, setQustpalette] = useState(false);
  const isPaletteMobileViewport = getUserDeviceDetails().isMobileDevice && typeof window !== 'undefined' && window.innerWidth < 768;
  const time = new Date();
  const [initialBatch, setInitialBatch] = useState(1);
  const userID = useAppSelector(state => state.login.userID)
  const [questionInSingleBatch, setQuestionInSingleBatch] = useState(5);
  const [actionStopWatch, setActionStopWatch] = useState(StopWatchActions.PAUSE);
  const [indexInNeed, setIndexInNeed] = useState(0);
  const questionQuotient = Math.floor(noOfQuestion / questionInSingleBatch);
  const questionRemainder = noOfQuestion % questionInSingleBatch;
  const questionBatch = (questionQuotient + (questionRemainder > 0 ? 1 : 0))
  time.setSeconds(time.getSeconds() + (timeDuration));
  const timer: any = useRef();
  const nextTimeEventDelay = useRef(15000);
  const nextTimeEventAt = useRef<number | null>(null);
  const testType = TestTypes.regular;
  const params = useParams()
  const [spendTime, setSpendTime] = useState(0);
  const [submitAnswer, setSubmitAnswer] = useState<any>({});
  const ref: any = useRef();
  const [isLoading, setIsLoading] = useState(true);
  const [questionsNotAvailableDialog, setQuestionsNotAvailableDialog] = useState(false);
  const [timerKey, setTimerKey] = useState(0);
  const [timerExpiry, setTimerExpiry] = useState<Date>(() => {
    const t = new Date();
    t.setSeconds(t.getSeconds() + timeDuration);
    return t;
  });
  // Stores pending resume info until questions are loaded from GET
  const pendingResumeRef = useRef<{ firstUnansweredIdx: number } | null>(null);

  const [hasSelectedOption, setHasSelectedOption] = useState(false);

  useEffect(() => {
    if (questionsStore[indexInNeed]) {
      setHasSelectedOption(!!questionsStore[indexInNeed].SelectedOption);
    }
  }, [indexInNeed, questionsStore]);

  useEffect(() => {
    if (isTestSeries) {
      postAllTestSeriesQuestion()
    } else {
      postAllQuestion()
    }
  }, []);

  // After questionsStore loads, apply the pending resume index if set
  useEffect(() => {
    if (questionsStore.length > 0 && pendingResumeRef.current !== null) {
      setIndexInNeed(pendingResumeRef.current.firstUnansweredIdx);
      pendingResumeRef.current = null;
    }
  }, [questionsStore.length]);

  useEffect(() => {
    if (initialBatch > 1 && initialBatch <= questionBatch) {
      if (initialBatch == questionBatch) {
        setQuestionInSingleBatch(questionRemainder)
      }
      if (isTestSeries) {
        getAllTestSeriesQuestions();
      } else {
        getAllQuestions();
      }
    }
  }, [initialBatch]);

  useEffect(() => {
    const userTestId = questionsStore[0]?.UserTestId;
    const isPaused = action === CountDownActions.PAUSE;
    let stopped = false;

    if (isLoading || !userTestId) {
      if (timer.current) {
        clearWorkerTimeout(timer.current);
        timer.current = null;
      }
      return;
    }

    if (isPaused) {
      if (nextTimeEventAt.current !== null) {
        nextTimeEventDelay.current = Math.max(0, nextTimeEventAt.current - Date.now());
        nextTimeEventAt.current = null;
      }
      if (timer.current) {
        clearWorkerTimeout(timer.current);
        timer.current = null;
      }
      return;
    }

    if (action === CountDownActions.RESUME) {
      postTimerTest({ userTestId, timeTake: 0 });
      if (timer.current) {
        clearWorkerTimeout(timer.current);
      }
      nextTimeEventAt.current = Date.now() + nextTimeEventDelay.current;
      const scheduleTimeEvent = () => {
        timer.current = setWorkerTimeout(async () => {
          if (stopped) return;

          const scheduledAt = nextTimeEventAt.current ?? Date.now();
          const eventsDue = Math.max(1, Math.floor((Date.now() - scheduledAt) / 15000) + 1);
          nextTimeEventAt.current = scheduledAt + eventsDue * 15000;
          nextTimeEventDelay.current = Math.max(0, nextTimeEventAt.current - Date.now());

          for (let eventIndex = 0; eventIndex < eventsDue && !stopped; eventIndex += 1) {
            void postTimerTest({ userTestId, timeTake: 15 }).catch(() => { });
          }

          if (!stopped) {
            scheduleTimeEvent();
          }
        }, Math.max(0, (nextTimeEventAt.current ?? Date.now()) - Date.now()));
      };
      scheduleTimeEvent();
    }

    return () => {
      stopped = true;
      if (nextTimeEventAt.current !== null) {
        nextTimeEventDelay.current = Math.max(0, nextTimeEventAt.current - Date.now());
      }
      if (timer.current) {
        clearWorkerTimeout(timer.current);
        timer.current = null;
      }
    };
  }, [action === CountDownActions.PAUSE, isLoading, questionsStore[0]?.UserTestId]);

  useEffect(() => {
    return () => {
      if (timer.current) {
        clearWorkerTimeout(timer.current);
        timer.current = null;
      }
      nextTimeEventAt.current = null;
    };
  }, []);

  useEffect(() => {
    let params: any = submitAnswer;
    if (params && params['UserTestId']) {
      params['timeSpend'] = ref.current.getStopWatchTimeHandler();
      if (isTestSeries) {
        postSubmitTestSeriesQuestionAnswer(params)
      } else {
        postSubmitQuestionAnswer(params)
      }
    }
  }, [submitAnswer])

  const postAllQuestion = () => {
    let params = {
      "testId": testId,
      "duration": timeDuration,
      "noOfQuestion": noOfQuestion

    }
    if (testId) {
      postQuestion(params).then((response: APIResponse) => {
        if (response?.ResponseType == APIStatus.SUCCESS) {
          if (response?.StatusMsg === "User Question Already Inserted." && response?.data?.length > 0) {
            // Pending test detected — calculate timer adjustment and first unanswered index
            const pendingQuestions = response.data;

            const firstUnansweredIdx = pendingQuestions.findIndex(
              (q: any) => q.SelectedOption === null && q.IsVisited === false
            );
            pendingResumeRef.current = { firstUnansweredIdx: firstUnansweredIdx >= 0 ? firstUnansweredIdx : 0 };

            const totalUsedSeconds = pendingQuestions.reduce(
              (sum: number, q: any) => sum + (q.TimeSpend || 0), 0
            );
            const remainingSeconds = Math.max(timeDuration - totalUsedSeconds, 0);
            const newExpiry = new Date();
            newExpiry.setSeconds(newExpiry.getSeconds() + remainingSeconds);
            setTimerExpiry(newExpiry);
            setTimerKey(prev => prev + 1);
          }
          // Always fetch full question data from GET
          getAllQuestions();
        } else {
          toast.error("Test Cannot be started")
        }
      })
    }
  }

  const postAllTestSeriesQuestion = () => {
    let params: any = {
      "examId": testId,
      "duration": timeDuration,
      "noOfQuestion": noOfQuestion,
      "testIds": testIds
    }
    if (examType1) {
      params.examType = 1;
    } else if (examType4) {
      params.examType = 3;
    } else {
      params.examType = 0;
    }
    if (testId) {
      postTestSeriesQuestion(params).then((response: APIResponse) => {
        if (response?.ResponseType == APIStatus.SUCCESS) {
          if (response?.StatusMsg === "User Question Already Inserted." && response?.data?.length > 0) {
            // Pending test detected — calculate timer adjustment and first unanswered index
            const pendingQuestions = response.data;

            const firstUnansweredIdx = pendingQuestions.findIndex(
              (q: any) => q.SelectedOption === null && q.IsVisited === false
            );
            pendingResumeRef.current = { firstUnansweredIdx: firstUnansweredIdx >= 0 ? firstUnansweredIdx : 0 };

            const totalUsedSeconds = pendingQuestions.reduce(
              (sum: number, q: any) => sum + (q.TimeSpend || 0), 0
            );
            const remainingSeconds = Math.max(timeDuration - totalUsedSeconds, 0);
            const newExpiry = new Date();
            newExpiry.setSeconds(newExpiry.getSeconds() + remainingSeconds);
            setTimerExpiry(newExpiry);
            setTimerKey(prev => prev + 1);
          }
          // Always fetch full question data from GET
          getAllTestSeriesQuestions();
        } else {
          toast.error("Test Cannot be started")
        }
      })
    }
  }

  const getAllQuestions = () => {
    let params = {
      "testId": testId,
      "pageNo": initialBatch,
      "pageSize": questionInSingleBatch
    }
    if (testId) {
      getQuestion(params).then((response: APIResponse) => {
        if (response?.ResponseType == APIStatus.SUCCESS) {
          const data = response.data || [];
          let appendedQuestions;
          if (questionsStore && questionsStore.length) {
            appendedQuestions = questionsStore.concat(data);
          } else {
            appendedQuestions = data;
          }

          if (!appendedQuestions.length) {
            setAllQuestions([]);
            setIsLoading(false);
            setQuestionsNotAvailableDialog(true);
            setAction(CountDownActions.PAUSE);
            setActionStopWatch(StopWatchActions.PAUSE);
            return;
          }

          setAllQuestions(appendedQuestions);
          if (initialBatch < questionBatch) {
            setInitialBatch(initialBatch + 1);
          } else {
            setIsLoading(false);
            setAction(CountDownActions.RESUME);
            setActionStopWatch(StopWatchActions.START);
          }
        } else {
        }
      });
    }
  }

  const getAllTestSeriesQuestions = () => {
    let params = {
      "examId": testId,
      "pageNo": initialBatch,
      "pageSize": questionInSingleBatch
    }
    if (testId) {
      getTestSeriesQuestion(params).then((response: APIResponse) => {
        if (response?.ResponseType == APIStatus.SUCCESS) {
          const data = response.data || [];
          let appendedQuestions;
          if (questionsStore && questionsStore.length) {
            appendedQuestions = questionsStore.concat(data);
          } else {
            appendedQuestions = data;
          }

          if (!appendedQuestions.length) {
            setAllQuestions([]);
            setIsLoading(false);
            setQuestionsNotAvailableDialog(true);
            setAction(CountDownActions.PAUSE);
            setActionStopWatch(StopWatchActions.PAUSE);
            return;
          }

          setAllQuestions(appendedQuestions);
          if (initialBatch < questionBatch) {
            setInitialBatch(initialBatch + 1);
          } else {
            setIsLoading(false);
            setAction(CountDownActions.RESUME);
            setActionStopWatch(StopWatchActions.START);
          }
        } else {
        }
      });
    }
  }

  const onClickPreiousQuestion = () => {
    if (indexInNeed > 0) {
      setIndexInNeed(indexInNeed - 1)
    }
  }

  const onClickNextQuestion = () => {
    questionsStore[indexInNeed]['IsVisited'] = true;
    if (indexInNeed < questionsStore.length - 1) {
      let params: any = {};
      params = {
        "UserTestId": questionsStore[indexInNeed].UserTestId,
        "QuestionId": questionsStore[indexInNeed].QuestionId,
        "SelectedOption": questionsStore[indexInNeed].SelectedOption,
        "IsFlag": questionsStore[indexInNeed].IsFlag,
        "previousSelectedOption": questionsStore[indexInNeed].previousSelectedOption
      };
      let selectedOption: string = params.SelectedOption;
      let previousSelectedOption: string = params.previousSelectedOption;
      if (previousSelectedOption != null && selectedOption == previousSelectedOption) {
        postTestSubmitAnswer();
      } else if (selectedOption != null) {
        postTestSubmitAnswer();
      } else {
        params['previousSelectedOption'] = params['SelectedOption'];
        questionsStore[indexInNeed].previousSelectedOption = questionsStore[indexInNeed].SelectedOption;
        setSubmitAnswer(params);
      }
      setIndexInNeed(indexInNeed + 1);
    }
  }

  const onClickEndTest = () => {
    setEndTestDialog(true);
  }

  const onClickPauseTest = () => {
    setPauesedialog(true)
  }

  const endTest = () => {
    if (timer.current) {
      clearWorkerTimeout(timer.current);
      timer.current = null;
    }
    nextTimeEventDelay.current = 15000;
    setEndTestDialog(false);
    setExpireTestDialog(false);
    let params = {
      "userTestId": questionsStore[0]['UserTestId'],
    }

    postFinalSubmitTest(params).then((response: APIResponse) => {
      if (response?.ResponseType == APIStatus.SUCCESS) {
        if (isTestSeries) {
          // navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${userID}?examId=${testId}&testType=1&userTestId=${questionsStore[0]['UserTestId']}`)
          navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${userID}`, { state: { examId: testId, testType: 1, userTestId: questionsStore[0]['UserTestId'], examType: examType1 ? "1" : (examType4 ? "3" : "") } })
        } else {
          // navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${userID}?testId=${testId}&testType=1&userTestId=${questionsStore[0]['UserTestId']}`)
          navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${userID}`, { state: { testId: testId, testType: 1, userTestId: questionsStore[0]['UserTestId'], examType: examType1 ? "1" : (examType4 ? "3" : "") } })
        }
      }
    })
    // onClickNextQuestion();
  }

  const pauseTest = () => {
    setAction(CountDownActions.PAUSE);
    setActionStopWatch(StopWatchActions.PAUSE)
    let params = {
      "userTestId": questionsStore[indexInNeed]['UserTestId'],
    }
    postPauseTest(params).then((response: APIResponse) => {
      if (response?.ResponseType == APIStatus.SUCCESS) {
      }
    })
  }

  const resumeTest = () => {
    setPauesedialog(false);
    setEndTestDialog(false);
    setAction(CountDownActions.RESUME);
    setActionStopWatch(StopWatchActions.START)
    let params = {
      "userTestId": questionsStore[0]['UserTestId'],
    }
    postResumeTest(params).then((response: APIResponse) => {
      if (response?.ResponseType == APIStatus.SUCCESS) {
      }
    })
  }

  const runningEventHandler = (isRunning: boolean) => {
    setIsTimerRunning(isRunning);
  }

  const expireEventHandler = () => {
    // as using worrker timeres, so mention window for default set time out
    window.setTimeout(() => {
      setAction(CountDownActions.PAUSE);
      setExpireTestDialog(true);
    }, 1000);
  }

  const jumpToQuestionHandler = (indexNew: number) => {
    questionsStore[indexInNeed]['IsVisited'] = true;
    let params: any = {};
    params = {
      "UserTestId": questionsStore[indexInNeed].UserTestId,
      "QuestionId": questionsStore[indexInNeed].QuestionId,
      "SelectedOption": questionsStore[indexInNeed].SelectedOption,
      "IsFlag": questionsStore[indexInNeed].IsFlag,
      "previousSelectedOption": questionsStore[indexInNeed].previousSelectedOption
    };
    let selectedOption: string = params.SelectedOption;
    let previousSelectedOption: string = params.previousSelectedOption;
    if (previousSelectedOption != null && selectedOption == previousSelectedOption) {
      postTestSubmitAnswer();
    } else if (selectedOption != null) {
      postTestSubmitAnswer();
    } else {
      params['previousSelectedOption'] = params['SelectedOption'];
      questionsStore[indexInNeed].previousSelectedOption = questionsStore[indexInNeed].SelectedOption;
      setSubmitAnswer(params);
    }
    setIndexInNeed(indexNew);
    setQustpalette(false);

    if (!(getUserDeviceDetails().device === "DESKTOP")) {
      setFullQuestionPaperMode(false);
    }

    toast.success(`Jumped to question ${indexNew + 1}`, {
      duration: 2000,
      position: 'top-center',
    });
  }

  const onClickSubmitionHandler = (params: any) => {
    postTestSubmitAnswer();
    setSubmitAnswer(params);
  }

  const updateTestQuestionHandler = (params: any) => {
    questionsStore[indexInNeed]['IsFlag'] = params['IsFlag'];
    questionsStore[indexInNeed]['SelectedOption'] = params['SelectedOption'];
    questionsStore[indexInNeed]['previousSelectedOption'] = params['previousSelectedOption'];
    questionsStore[indexInNeed]['IsVisited'] = true;
    setHasSelectedOption(!!params['SelectedOption']);
  }

  const onClickPreiousQuestionHandler = () => {
    onClickPreiousQuestion()
  }

  const setQuestionpaletteHandler = () => {
    setQustpalette(!Qustpalette)
  }

  const onClickNextQuestionHandler = () => {
    onClickNextQuestion()
  }

  const setFullQuestionPaperModeHandler = (value: boolean) => {
    setFullQuestionPaperMode(value)
    setQustpalette(!Qustpalette)
  }

  const setinstructionHadndler = (value: boolean) => {
    setinstruction(value)
    setQustpalette(false)
  }

  const onClickEndTestHandler = () => {
    onClickEndTest()
  }

  const setPauesedialogHandler = (value: boolean) => {
    setPauesedialog(value);
  }

  const pauseTestHandler = () => {
    pauseTest()
  }

  const resumeTestHandler = () => {
    resumeTest()
  }

  const setEndTestDialogHandler = (value: boolean) => {
    setEndTestDialog(value)
  }

  const endTestHandler = () => {
    endTest()
  }

  const endTestHandlerWithoutResult = () => {
    if (timer.current) {
      clearWorkerTimeout(timer.current);
      timer.current = null;
    }
    setQuestionsNotAvailableDialog(false);
    setIsLoading(false);
    navigation('/');
  }

  const postTestSubmitAnswer = () => {
    getStopWatchSpendTime();
  }

  const getStopWatchSpendTime = () => {
    setAction(StopWatchActions.RESET);
  }

  const postSubmitQuestionAnswer = (params: any) => {
    postSubmitQuestion(params).then((response: APIResponse) => {
      if (response?.ResponseType == APIStatus.SUCCESS) {
        setAction('')
      }
    })
  }

  const postSubmitTestSeriesQuestionAnswer = (params: any) => {
    postSubmitTestSeriesQuestion(params).then((response: APIResponse) => {
      if (response?.ResponseType == APIStatus.SUCCESS) {
        setAction('')
      }
    })
  }

  const onActionChange = (time: number) => {
    setSpendTime(time);
  }

  const askNextTestQuestionHandler = (index: number) => {
  }

  const onClickMarkForReview = (params: any) => {
    if (params['IsFlag'] == true) {
      toast(
        <span className="qust-toast-card tw-flex ">
          <div>
            <img src={MarkReview} alt="MarkReview" />
          </div>
          <div className="tw-ml-2">
            <p className="marked-span">Marked For Review</p>
            <p className="marked-status">
              You have marked the question for review.
            </p>
          </div>
        </span>
      );
    } else if (params['IsFlag'] == false) {
      toast(
        <span className="qust-toast-card tw-flex ">
          <div>
            <img src={MarkReview} alt="MarkReview" />
          </div>
          <div className="tw-ml-2">
            <p className="marked-span">Unmarked For Review</p>
            <p className="marked-status">
              You have unmarked the question for review.
            </p>
          </div>
        </span>
      );

    }

  }

  const onClickBackButtonHandler = (value: boolean) => {
    setQustpalette(value);
    setFullQuestionPaperMode(false);
    setinstruction(false);
  }

  useEffect(() => {
    document.body.classList.add("tw-overflow-hidden");
    return () => document.body.classList.remove("tw-overflow-hidden");
  }, []);

  console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaa",questionsStore.length);

  return (
    <>

      <div className="test-question-container">
        <div className="test-qust-cards-container">
          {
            !(getUserDeviceDetails().device === "DESKTOP") ?
              !Qustpalette && <div className="test-qust-header sticky top-0 tw-items-center">
                <div className="left-qust-header p-2" style={{ height: '60px' }}>
                  {/* {
                    isLoading ? <div className="tw-h-6 tw-w-24 tw-bg-gray-200 tw-rounded"></div> :
                  } */}

                  <div className="t-qust-heading">{testName}</div>

                  {/* {
                    isLoading ? <div className="tw-h-6 tw-w-24 tw-bg-gray-200 tw-rounded"></div> : */}
                  <div className="tw-flex tw-items-center tw-justify-start tw-gap-2">
                    {
                      !(examType1 || examType4) && <ClockTimer threshold={questionsStore[indexInNeed]?.DifficultyLevelAvgTime} isRunning={action !== 'pause'} resetKey={indexInNeed} hasSelectedOption={hasSelectedOption} />
                    }
                    {/* <ClockTimer threshold={5} isRunning={isTimerRunning} resetKey={indexInNeed} hasSelectedOption={hasSelectedOption} /> */}


                    <div className="t-qust-timer p-0 pl-2">

                      <span className="timer-span">
                        <MyTimer key={timerKey} expiryTimestamp={timerExpiry} action={isLoading || (!(questionsStore.length > 0)) ? CountDownActions.PAUSE : action} runningEventHandler={runningEventHandler} expireEventHandler={expireEventHandler} />
                      </span>

                      <StopWatch action={action} actionStopWatch={actionStopWatch} onActionChange={onActionChange} askNextSpeedTestQuestionHandler={askNextTestQuestionHandler} indexInNeed={indexInNeed} ref={ref} />
                      <span className="pause-svg" onClick={() => onClickPauseTest()} >
                        {isTimerRunning ?
                          <img src={PauseSvg} alt="Pause-Svg" />
                          : <img src={Play} alt="Play-Svg" />

                        }
                      </span>
                    </div>


                  </div>
                  {/* } */}

                </div>

                <div className="quest-palette-header p-2 pt-3" style={{ height: '60px' }}>{(fullQuestionPaperMode ? 'Question Paper' : 'Question Palette')}</div>
              </div> : <div className="test-qust-header sticky top-0 tw-items-center">
                <div className="left-qust-header p-2" style={{ height: '60px' }}>
                  {/* {
                    isLoading ? <div className="tw-h-6 tw-w-24 tw-bg-gray-200 tw-rounded"></div> : 
                  } */}
                  <div className="t-qust-heading">{testName}</div>


                  {/* {
                    isLoading ? <div className="tw-h-6 tw-w-24 tw-bg-gray-200 tw-rounded"></div> :  */}
                  <div className="tw-flex tw-items-center tw-justify-start tw-gap-2">
                    {
                      !(examType1 || examType4) && <ClockTimer threshold={questionsStore[indexInNeed]?.DifficultyLevelAvgTime} isRunning={action !== 'pause'} resetKey={indexInNeed} hasSelectedOption={hasSelectedOption} />
                    }
                    {/* <ClockTimer threshold={5} isRunning={isTimerRunning} resetKey={indexInNeed} hasSelectedOption={hasSelectedOption} /> */}
                    <div className="t-qust-timer p-0 pl-2">

                      <span className="timer-span">
                        <MyTimer key={timerKey} expiryTimestamp={timerExpiry} action={isLoading || (!(questionsStore.length > 0)) ? CountDownActions.PAUSE : action} runningEventHandler={runningEventHandler} expireEventHandler={expireEventHandler} />
                      </span>

                      <StopWatch action={action} actionStopWatch={actionStopWatch} onActionChange={onActionChange} askNextSpeedTestQuestionHandler={askNextTestQuestionHandler} indexInNeed={indexInNeed} ref={ref} />
                      <span className="pause-svg" onClick={() => onClickPauseTest()} >
                        {isTimerRunning ?
                          <img src={PauseSvg} alt="Pause-Svg" />
                          : <img src={Play} alt="Play-Svg" />

                        }
                      </span>
                    </div>
                  </div>
                  {/* } */}


                </div>

                <div className="quest-palette-header p-2 pt-3" style={{ height: '60px' }}>{(fullQuestionPaperMode ? 'Question Paper' : 'Question Palette')}</div>
              </div>
          }


          <div className="qust-palette-container">
            <div className="test-question-card">
              {isLoading ? (
                <div className="qust-container tw-p-6">
                  <div className="tw-animate-pulse">
                    {/* header bar: Q/A tabs + question count + subject tags */}
                    <div className="tw-flex tw-items-center tw-gap-3 tw-mb-6">
                      <div className="tw-h-8 tw-w-8 tw-bg-gray-200 tw-rounded"></div>
                      <div className="tw-h-8 tw-w-8 tw-bg-gray-200 tw-rounded"></div>
                      <div className="tw-h-5 tw-w-40 tw-bg-gray-200 tw-rounded"></div>
                      <div className="tw-h-7 tw-w-24 tw-bg-gray-200 tw-rounded-full"></div>
                      <div className="tw-h-7 tw-w-40 tw-bg-gray-200 tw-rounded-full"></div>
                    </div>
                    {/* question text lines */}
                    <div className="tw-space-y-3 tw-mb-8">
                      <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-full"></div>
                      <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-5/6"></div>
                      <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-3/4"></div>
                    </div>
                    {/* 4 option rows */}
                    {[1, 2, 3, 4].map(i => (
                      <div key={i} className="tw-flex tw-items-center tw-gap-3 tw-border tw-border-gray-200 tw-rounded-lg tw-p-4 tw-mb-3">
                        <div className="tw-h-6 tw-w-6 tw-bg-gray-200 tw-rounded-full tw-shrink-0"></div>
                        <div className="tw-h-4 tw-bg-gray-200 tw-rounded tw-w-24"></div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : questionsStore[indexInNeed] ? (
                <div className="qust-container">
                  <QuestionCardIndex question={questionsStore[indexInNeed]} index={indexInNeed} total={questionsStore.length} testType={testType} testId={testId} onClickSubmitionHandler={onClickSubmitionHandler} updateTestQuestionHandler={updateTestQuestionHandler} actionStopWatch={actionStopWatch} isTestSeries={isTestSeries} onClickMarkForReview={onClickMarkForReview} />
                </div>
              ) : null}
              {/* {fullQuestionPaperMode && questionsStore.length && 
              <div className="qust-container">
                <FullQuestionPaper questions={questionsStore} />
              </div>
              } */}
              <div className="tw-sticky bottom-0">
                <QuestionPaperFooter isLoading={isLoading} testType={testType} fullQuestionPaperMode={fullQuestionPaperMode} index={indexInNeed} questionsStoreLength={questionsStore.length} instruction={instruction} Qustpalette={Qustpalette} onClickPreiousQuestionHandler={onClickPreiousQuestionHandler} setQuestionpaletteHandler={setQuestionpaletteHandler} onClickNextQuestionHandler={onClickNextQuestionHandler} setFullQuestionPaperModeHandler={setFullQuestionPaperModeHandler} setinstructionHadndler={setinstructionHadndler} onClickEndTestHandler={onClickEndTestHandler} isTestSeries={isTestSeries} />
              </div>
            </div>

            <div>

              <div className={`qust-palette-card  ${(instruction || Qustpalette) ? 'qust-mob-card isactive-card' : ''}`}>
                {instruction && (
                  <InstructionSetIndex setinstructionValue={setinstruction} generalInstruction={generalInstruction} setQustpalette={setQustpalette} />
                )}

                {isLoading && !isPaletteMobileViewport && (
                  <div className="tw-animate-pulse" style={{ padding: '25px 32px' }}>
                    {/* "Question Number" heading */}
                    <div className="tw-h-5 tw-w-40 tw-bg-gray-200 tw-rounded tw-mb-5"></div>
                    {/* subject label */}
                    <div className="tw-h-3 tw-w-16 tw-bg-gray-200 tw-rounded tw-mb-3"></div>
                    {/* grid of number boxes matching 45x45 with margin 17px 20px */}
                    <div className="tw-flex tw-flex-wrap" style={{ margin: '0 -20px' }}>
                      {[...Array(20)].map((_, i) => (
                        <div
                          key={i}
                          className="tw-bg-gray-200 tw-rounded"
                          style={{ width: 45, height: 45, margin: '17px 20px', flexShrink: 0 }}
                        ></div>
                      ))}
                    </div>
                  </div>
                )}
                {!isLoading && !isPaletteMobileViewport && !instruction && <QuestionPaletteIndex questions={questionsStore} jumpToQuestionHandler={jumpToQuestionHandler} testType={testType} fullQuestionPaperMode={fullQuestionPaperMode} activeIndex={indexInNeed} onClickBackButtonHandler={onClickBackButtonHandler} />}

                {!isLoading && isPaletteMobileViewport && !instruction && Qustpalette && <QuestionPaletteIndex questions={questionsStore} jumpToQuestionHandler={jumpToQuestionHandler} testType={testType} onClickBackButtonHandler={onClickBackButtonHandler} fullQuestionPaperMode={fullQuestionPaperMode} activeIndex={indexInNeed} />}

              </div>
              <QuestionpaperrightFooter isLoading={isLoading} testType={testType} fullQuestionPaperMode={fullQuestionPaperMode} instruction={instruction} setFullQuestionPaperModeHandler={setFullQuestionPaperModeHandler} setinstructionHadndler={setinstructionHadndler} onClickEndTestHandler={onClickEndTestHandler} />
            </div>

          </div>



        </div>
      </div>

      <QuestionsNotAvailableDialog questionsNotAvailbleDialog={questionsNotAvailableDialog} endTestHandlerWithoutResult={endTestHandlerWithoutResult} />

      <PauseTestDialog Pauesedialog={Pauesedialog} setPauesedialogHandler={setPauesedialogHandler} pauseTestHandler={pauseTestHandler} resumeTestHandler={resumeTestHandler} />

      <EndTestDialog endTestDialog={endTestDialog} setEndTestDialogHandler={setEndTestDialogHandler} endTestHandler={endTestHandler} resumeTestHandler={resumeTestHandler} totalQuestions={questionsStore.length} answeredQuestions={questionsStore.filter((q: any) => q.SelectedOption !== null && q.SelectedOption !== undefined && q.SelectedOption !== "").length} testType={testType} />

      <ExpireTimeEndTestDialog expireTestDialog={expireTestDialog} endTestHandler={endTestHandler} />
    </>
  );
};
